import React from "react";

export default function OurJourney({
  title = "Our Journey",
  timelineData = [],
}) {
  // Parse timeline data safely (string or array)
  let timeline = [];
  try {
    if (typeof timelineData === "string") {
      timeline = JSON.parse(timelineData || "[]");
    } else if (Array.isArray(timelineData)) {
      timeline = timelineData;
    }
  } catch (error) {
    console.error("Error parsing timeline data:", error);
    timeline = [];
  }

  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 bg-gradient-to-br from-[#f9fafb] to-white">
      <div className="container mx-auto max-w-7xl">
        {/* Header */}
       {/* Header */}
        {title && (
          <div className="flex justify-center items-center mb-8 sm:mb-10 md:mb-14">
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-center text-[#1D6043]">
              {title}
            </h2>
          </div>
        )}


        {/* Timeline */}
        <div className="relative">
          {/* Connector line for large screens */}
          <div
            className="hidden md:block absolute top-10 left-[6%] right-[6%] h-0 border-t-[3px] border-dotted z-0"
            style={{ borderColor: "#2299D5" }}
          />

          {/* Timeline items */}
          <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-8 sm:gap-10 md:gap-12">
            {timeline.map((item, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center transition-transform duration-300 hover:scale-[1.03]"
              >
                {/* Step number */}
                <div
                  className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mb-3 sm:mb-5 shadow-lg border-4 border-white"
                  style={{ backgroundColor: "#2299D5" }}
                >
                  <span className="text-lg sm:text-xl md:text-2xl font-bold text-white">
                    {index + 1}
                  </span>
                </div>

                {/* Text block */}
                <div className="space-y-1 sm:space-y-2 md:space-y-3 px-2 w-full max-w-[240px]">
                  <h3 className="font-semibold text-blue-600 text-base sm:text-lg md:text-xl">
                    {item.title || "Milestone"}
                  </h3>
                  <p className="text-indigo-700 font-medium text-sm sm:text-base">
                    {item.year || "Year"}
                  </p>
                  <p className="text-gray-600 text-xs sm:text-sm md:text-base leading-relaxed">
                    {item.event || "Event description"}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Empty state */}
          {timeline.length === 0 && (
            <p className="text-center text-gray-500 text-sm sm:text-base mt-6">
              No milestones to display.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
